var map = {
	"./academies.entity.js": "9722",
	"./academy_course_period.entity.js": "e5ee",
	"./academy_summary.entity.js": "dff0",
	"./academy_tool.entity.js": "9a45",
	"./academy_toolkit.entity.js": "61d2",
	"./academy_user.entity.js": "4d0a",
	"./business_report.entity.js": "aeed",
	"./course_Period_Summary.entity.js": "3555",
	"./course_Summary.entity.js": "e05e",
	"./course_period_user_summary.entity.js": "160c",
	"./courses.entity.js": "8ebb",
	"./events.entity.js": "730c",
	"./oban_jobs.entity.js": "9fd5",
	"./posts.entity.js": "80f8",
	"./programme_period_summary.entity.js": "fa03",
	"./programme_period_user_summary.entity.js": "137f",
	"./programmes.entity.js": "a797",
	"./relatedLinks.entity.js": "c520",
	"./tool_Summary.entity.js": "fda4",
	"./toolkits.entity.js": "90b6",
	"./tools.entity.js": "2360",
	"./tootkit_Summary.entity.js": "477d",
	"./user_Summary.entity.js": "ff7d",
	"./user_profile_summary.entity.js": "306a",
	"./users.entity.js": "5811"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "20fe";